var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageChannel"},[_c('transition',{attrs:{"name":"PageGroupTranstion","enter-active-class":"animated PageGroupFadeIn"}},[_c('div',[_c('FieldForm',{attrs:{"cancelable":false,"isnew":false,"formfields":_vm.channel.page},on:{"save":_vm.save}}),_vm._v(" "),_c('router-view')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a004c26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageChannel.vue
// module id = null
// module chunks = 